import { getCookie, setCookie } from './cookies';

/**
 *
 */
window.addEventListener('load', () => {
  if (document.querySelector('.gdpr-alert')
    && !window.location.hostname.includes('graphics')) {
    if (!getCookie('cookies-alert-closed')) {
      document.querySelector('.gdpr-alert').classList.remove('hidden');
      document.querySelector('.gdpr-alert button').addEventListener('click', () => {
        setCookie('cookies-alert-closed', true, 365);
        document.querySelector('.gdpr-alert').classList.add('hidden');
      });
    }
  }
});
